export default __webpack_public_path__ + "static/media/gallery-2.4dba067b.jpg";